<template>
    <div class="problem_page page" id="problem_page">
        <div class="top_bg">
            <!--      <img src="../assets/problem_bg.png">-->
            <img :src="banner?api+banner:require('../assets/download_bg.png')">
        </div>

        <b-container class="problem_content my_content">
            <p class="title">{{ title }}</p>

            <div v-for="(item,index) in problemList" class="problem_item" :key="item.id">

                <b-button v-b-toggle="'collapse-'+index" class="list" @click="itemClick(item)">
                    {{ item.name }}
                    <img src="../assets/down.png" class="right" :class="{'icon_down':item.status1}">
                </b-button>

                <b-collapse :visible="index === 0" v-bind:id="'collapse-'+index" class="mt-2">
                    <b-card class="first_content">
                        <div v-for="(item2, index2) in item.children" :key="item2.id">
                            <b-button v-b-toggle="'collapse-'+index2+'-inner'" size="sm" class="second_list"
                                      @click="itemClick2(item2)">
                                <img src="../assets/down2.png" :id="'down2'+item2.id">
                                {{ item2.name }}
                            </b-button>
                            <b-collapse v-bind:id="'collapse-'+index2+'-inner'" class="mt-2">
                                <b-card class="border-0">

                                    <div v-html="item2.content">

                                    </div>

                                </b-card>
                            </b-collapse>
                        </div>
                    </b-card>
                </b-collapse>
            </div>
        </b-container>

    </div>
</template>

<script>
    import {getTypeList, getDownloadList} from "../api/HomeService";
    import {api} from '../api/api';

    export default {
        name: "Problem",
        data() {
            return {
                languageNum: window.localStorage.getItem("languageNum"),
                problemList: [],
                typeId: '',
                title: '',
                banner: '',
                api: api
            }
        },
        methods: {
            itemClick2(item) {
                item.status1 = !item.status1
                if (item.status1) {
                    document.getElementById('down2' + item.id).classList.add('icon_down')
                } else {
                    document.getElementById('down2' + item.id).classList.remove('icon_down')
                }
                // this.$set(item, "status1", !item.status1)
                setTimeout(() => {
                    this.setHeight()
                }, 200)
            },

            itemClick(item) {
                this.$set(item, "status1", !item.status1)
                setTimeout(() => {
                    this.setHeight()
                }, 200)
            },

            getTypeList() {
                let sendData = {
                    languageNum: this.languageNum,
                    classType: 2
                }
                getTypeList(sendData, data => {
                    // this.problemList = data
                    for (let i = 0; i < data.length; i++) {
                        this.getDetailList(data[i], i)
                    }
                })
            },

            getDetailList(item, index) {

                let sendData = {
                    languageNum: this.languageNum,
                    typeId: item.id
                }

                getDownloadList(sendData, data => {
                    item.children = data
                    // if (index === 0) {
                    //   item.status1 = true;
                    // }
                    this.problemList.push(item)
                })
            },

            setHeight() {
                let appDom = document.getElementById("problem_page");
                let footerDom = document.getElementById("footer");
                let windowH = document.documentElement.clientHeight;
                let appH = appDom.offsetHeight;
                let footerH = footerDom.offsetHeight
                console.log(windowH, (appH + footerH))
                if (windowH > (appH + footerH)) {
                    footerDom.style.position = 'fixed'
                }
            },
        },

        destroyed() {
            let footerDom = document.getElementById("footer");
            footerDom.style.position = "unset"
        },

        mounted() {
            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
                            this.title = menuList[i].children[j].title
                            this.banner = menuList[i].children[j].banner
                        }
                    }
                }
            }
            this.getTypeList();
        }
    }
</script>

<style scoped lang="scss" src="../css/problem.scss">

</style>